module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Process Lead":"Leads"},"fr":{"Process Lead":"Références"}}')
  delete Component.options._Ctor
}
